import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import InfoTwoToneIcon from '@mui/icons-material/InfoTwoTone';

const LabelContainer = () => {
  const headers = [
    { key: 'layer', label: 'Layer', info: 'Soil layer ID' },
    { key: 'z', label: 'z', info: 'Depth of soil layer (m)' },
    { key: 'n', label: 'N', info: 'Measured SPT-N value in the field' },
    { key: 'uscs', label: 'USCS', info: 'Soil type according to Unified Soil Classification System' },
    {
      key: 'ce',
      label: (
        <>
          C<sub>e</sub>
        </>
      ),
      info: 'Energy correction factor',
    },
    {
      key: 'cb',
      label: (
        <>
          C<sub>b</sub>
        </>
      ),
      info: 'Borehole diameter correction factor',
    },
    {
      key: 'cs',
      label: (
        <>
          C<sub>s</sub>
        </>
      ),
      info: 'Hammer type correction factor',
    },
    {
      key: 'cr',
      label: (
        <>
          C<sub>r</sub>
        </>
      ),
      info: 'Rod length correction factor',
    },
    {
      key: 'cn',
      label: (
        <>
          C<sub>n</sub>
        </>
      ),
      info: 'Overburden pressure correction factor',
    },
    {
      key: 'n160',
      label: (
        <>
          (N<sub>1</sub>)<sub>60</sub>
        </>
      ),
      info: 'Corrected SPT value for 60% energy level and 1 atm',
    },
    { key: 'fc', label: 'FC', info: 'Fine content (%)' },
    {
      key: 'n160f',
      label: (
        <>
          (N<sub>1</sub>)<sub>60,f</sub>
        </>
      ),
      info: 'Corrected SPT value according to fine content (FC)',
    },
    {
      key: 'crrm75',
      label: (
        <>
          CRR<sub>M7.5</sub>
        </>
      ),
      info: 'CRR M7.5',
    },
    { key: 'sigma', label: <>&sigma;</>, info: 'Total vertical stress' },
    { key: 'sigmaPrime', label: <>&sigma;&apos;</>, info: 'Effective vertical stress' },
    { key: 'rd', label: 'rd', info: 'Stress reduction factor' },
    {
      key: 'tauR',
      label: (
        <>
          &tau;<sub>R</sub>
        </>
      ),
      info: 'Liquefaction resistance of soil',
    },
    {
      key: 'taueq',
      label: (
        <>
          &tau;<sub>eq</sub>
        </>
      ),
      info: 'Average cyclic shear stress',
    },
    { key: 'fs', label: 'FS', info: 'Factor of safety agains liquefaction' },
    { key: 'result', label: 'Result', info: 'Result' },
    { key: 'details', label: 'Details', info: 'Open/close calculation details for this layer' },
  ];

  return (
    <div className="labelContainer liqLayerRow liqLabelRow">
      {headers.map((header) => (
        <div key={header.key} className="liqHeaderCell">
          <span className="liqHeaderCellLabel">{header.label}</span>
          {header.info ? (
            <Tooltip title={header.info} arrow placement="bottom" TransitionComponent={Zoom}>
              <span className="liqHeaderInfoIconWrap" aria-hidden="true">
                <InfoTwoToneIcon fontSize="inherit" />
              </span>
            </Tooltip>
          ) : null}
        </div>
      ))}
    </div>
  );
};
export default React.memo(LabelContainer);
